import { styled } from '@mui/material/styles';

import { Section } from './styled';
import { AccessCodeForm } from './AccessCodeForm';

const PREFIX = 'AccessCode';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledSection = styled(Section)({
  [`& .${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    fontSize: '14px',
  },
});

export const AccessCode = (props) => {
  const { fields, append, remove, control, controlledAccessCodes, errors } = props;

  return (
    <StyledSection>
      <div className="section__header">
        <p className="section__title">Codes:</p>
      </div>
      <div className="section__body">
        <div className={classes.container}>
          <AccessCodeForm
            fields={fields}
            append={append}
            remove={remove}
            control={control}
            controlledAccessCodes={controlledAccessCodes}
            errors={errors}
          />
        </div>
      </div>
    </StyledSection>
  );
};
